import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Cookies from 'js-cookie'

// 更新token

const version = Cookies.get('admin-version', { domain: process.env.REACT_APP_DOMAIN })

if (version !== process.env.REACT_APP_VERSION) {
    // 如果cookie中的version number与当前不一致，则清空token并更新version number到cookies
    Cookies.set("admin-version", process.env.REACT_APP_VERSION, {
        expires: 7,
        domain: process.env.REACT_APP_DOMAIN,
    });
    if (version) {
        Cookies.remove(process.env.REACT_APP_TOKEN_KEY, { domain: process.env.REACT_APP_DOMAIN })
    }

}


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
